import type { ChangeEvent, JSX } from 'react';
import { useState } from 'react';

import MaterialSymbol from 'components/material-symbols';

import * as Input from 'components/form/inputs/';

interface PasswordFieldProps {
	name: string;
	value?: string;
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
	validate?: () => boolean;
}

/**
 * PasswordField component
 *
 * A password input field with toggleable visibility.
 * Supports both controlled and uncontrolled input, with a minimum length validation.
 */

export default function PasswordField({
	name,
	value,
	onChange,
	validate,
}: PasswordFieldProps): JSX.Element {
	const [pw, setPw] = useState('');
	const [showPassword, setShowPassword] = useState(false);

	const toggleShowPassword = () => setShowPassword(!showPassword);

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (onChange) {
			onChange(e);
		} else {
			setPw(e.target.value);
		}
	};

	return (
		<Input.Field
			name={name}
			value={value || pw}
			onChange={handleChange}
			type={showPassword ? 'text' : 'password'}
			minLength={8}
			required
			validate={validate}>
			<Input.Suffix onClick={toggleShowPassword}>
				<MaterialSymbol variant="visibility_off" />
			</Input.Suffix>
		</Input.Field>
	);
}
